module.exports = __webpack_public_path__ + "static/portfolio-4-3b1b07846f28256d69d4b4c8d450e374.jpg";